import { renderAsync } from 'docx-preview/dist/docx-preview.min.js'
import html2pdf from 'html2pdf.js/src/index.js'

export function isBlobErrorResponse(response) {
    return response instanceof Blob && response.type === 'application/json'
}

export async function getBlobErrorMsg(blob, defaultMsg = '操作失败') {
    if (!isBlobErrorResponse(blob)) {
        return null
    }
    try {
        const data = JSON.parse(await blob.text())
        return data.msg || data.message || defaultMsg
    } catch (e) {
        return defaultMsg
    }
}

export const downLoadFile=(response,name,num,type='docx')=> {
    let blob;
    if (response instanceof Blob) {
        blob = response;
    } else if (response.data instanceof Blob) {
        blob = response.data;
    } else {
        // 如果不是Blob，尝试转换
        blob = new Blob([response], {
            // 类型是word
            type:'application/vnd.ms-word'
        });
    }
    // 创建下载链接
    const downloadUrl = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = downloadUrl;

    // 生成文件名（可以根据时间或从URL提取）
    link.download = `${name}-${num}.${type}`;

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    // 清理
    setTimeout(() => {
        window.URL.revokeObjectURL(downloadUrl);
    }, 100);
}
//附件预览
export const  previewFile=async (response)=> {
    let blob;
    if (response instanceof Blob) {
        blob = response;
    } else if (response.data instanceof Blob) {
        blob = response.data;
    } else {
        // 如果不是Blob，尝试转换
        blob = new Blob([response], {
            // 类型是word
            type:'application/vnd.ms-word'
        });
    }
    // 2. 创建临时容器渲染 Word
    const container = document.createElement('div');
    await renderAsync(blob, container, null, {
        className: 'docx-doc',
        ignoreWidth: false,
    });

    // 3. 转 PDF
    const opt = {
        margin: 10,
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { scale: 2, useCORS: true },
        jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
    };

    const pdfBlob = await html2pdf().from(container).set(opt).output('blob');
    const pdfUrl = URL.createObjectURL(pdfBlob);

    // 4. 新标签页打开预览
    window.open(pdfUrl, '_blank');
    // 清理
    setTimeout(() => URL.revokeObjectURL(pdfUrl), 3000);

}